import * as Yup from 'yup';

export const productSchema = Yup.object().shape({
  name: Yup.string().required("Por favor, informe o nome."),
 
});


export const configPizzaSchema = Yup.object().shape({
  
})
